export default __webpack_public_path__ + "static/media/northface.15209f86.jpg";